(function () {
  'use strict';

  angular
    .module('app')
    .component('confirmXmlAtvCrReceptionStatusLabel', confirmXmlAtvCrReceptionStatusLabel());

  function confirmXmlAtvCrReceptionStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: ConfirmXmlAtvCrReceptionStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  ConfirmXmlAtvCrReceptionStatusLabelComponent.$inject = ['$translate'];

  function ConfirmXmlAtvCrReceptionStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function (changes) {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass = 'default';
      let statusIcon = 'spinner';
      let statusTitle = '-';

      switch (vm.status) {
        case 'pending':
          statusClass = 'primary';
          statusIcon = 'spinner';
          statusTitle = 'PENDING';
          break;
        case 'accepted':
          statusClass = 'success';
          statusIcon = 'check';
          statusTitle = 'ACCEPTED';
          break;
        case 'accepted_partially':
          statusClass = 'warning';
          statusIcon = 'check-square-o';
          statusTitle = 'PARTIALLY_ACCEPTED';
          break;
        case 'rejected':
          statusClass = 'danger';
          statusIcon = 'ban';
          statusTitle = 'REJECTED';
          break;
        case 'fail':
          statusClass = 'danger';
          statusIcon = 'exclamation-triangle';
          statusTitle = 'FAILED';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
